// extracted by mini-css-extract-plugin
export default {"icon":"Icon_icon__Nrb5T","disabled":"Icon_disabled__qKldM"};